import BaseMutations from '@/store/base/mutations'

// const module = 'companies'

export default BaseMutations({
  //
})